import { Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';

// Component for Variables content
const OpenAPIOverview = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box style={{
            display: 'flex', flexDirection: 'column', gap: '16px', flex: 1, overflowY: 'auto',
            p: 3
        }}>

            <Typography
                variant="body1"
                style={{ width: isMediumScreen ? '100%' : '60%' }}
            >
                <strong>OpenAPI & Swagger Integration</strong>
                <br /><br />
                <p>
                    Hawkclient has an option to create OpenAPIs Spec at collection level. Effortlessly create and design your APIs at the collection level using Swagger YAML. Simplify API documentation and testing with full OpenAPI support.
                </p>

            </Typography>
            <img
                src="/openAPI.png"
                alt="openAPI"
                style={{
                    width: isMediumScreen ? '100%' : '65%',
                    // maxWidth: '800px',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '8px',
                }}
            />
        </Box>
    )
};

export default OpenAPIOverview;